var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-close",style:(_vm.style),attrs:{"data-toggle":"tooltip","title":_vm.t}})}
var staticRenderFns = []

export { render, staticRenderFns }